var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Component, createElement } from 'react';
import { Menu as AntMenu } from 'antd';
import { map, assign } from 'lodash';
import { Image } from '../image';
import { Icon } from '../icon';
import { Text } from '../text';
import { ComponentsManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';

var Nav = function (_super) {
  __extends(Nav, _super);

  function Nav() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 根据当前路由来确定 active 状态的 menuItem
   */


  Nav.prototype.getSelectedKey = function (menu) {
    var items = menu.items;
    var pathname;
    var location = this.props.location;

    if (location) {
      pathname = location.pathname;
    }

    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
      var item = items_1[_i];

      if (item.type === 'menu') {
        var selectedKey = this.getSelectedKey(item);

        if (selectedKey) {
          return selectedKey;
        }
      } else {
        if (pathname && item.route && services.navigation.isPathMatched(pathname, item.route)) {
          return item.key.toString();
        }
      }
    }

    return undefined;
  };
  /**
   * 点击 menuItem 时调用，可获得当前选中的menuItem，用来展示当前active状态的menuItem
   */


  Nav.prototype.handleClick = function (menuItem) {
    var item = menuItem.item; // 路由跳转

    services.behaviorHandle(item.props);
  };

  Nav.prototype.render = function () {
    var selectedKeys = this.getSelectedKey(this.props);
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        mode = _a.mode,
        theme = _a.theme,
        defaultSelectedKeys = _a.defaultSelectedKeys,
        defaultOpenKeys = _a.defaultOpenKeys,
        openKeys = _a.openKeys,
        onOpenChange = _a.onOpenChange;
    var props = {
      className: className,
      style: style,
      mode: mode,
      theme: theme,
      defaultSelectedKeys: defaultSelectedKeys ? [defaultSelectedKeys] : [],
      defaultOpenKeys: defaultOpenKeys,
      onOpenChange: onOpenChange,
      onClick: this.handleClick,
      selectedKeys: selectedKeys ? [selectedKeys] : []
    };

    if (openKeys) {
      assign(props, {
        openKeys: openKeys
      });
    }

    return React.createElement(AntMenu, __assign({}, props), this.renderSubMenu(this.props));
  };

  Nav.prototype.renderSubMenu = function (menu) {
    var _this = this;

    var items = menu.items;
    return map(items, function (item) {
      if (item.privilege) {
        var _a = item.privilege,
            path = _a.path,
            level = _a.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      if (item.type === 'menu') {
        return React.createElement(AntMenu.SubMenu, {
          key: item.key,
          title: _this.renderItem(item)
        }, _this.renderSubMenu(item));
      } else {
        return _this.renderMenuItem(item);
      }
    });
  };

  Nav.prototype.renderMenuItem = function (item) {
    if (item.privilege) {
      var _a = item.privilege,
          path = _a.path,
          level = _a.level;

      if (!services.privilege.check(path, level)) {
        return undefined;
      }
    }

    var key = item.key,
        route = item.route,
        actions = item.actions,
        action = item.action;
    var props = {
      key: key,
      route: route,
      actions: actions,
      action: action
    };
    return React.createElement(AntMenu.Item, __assign({}, props), this.renderItem(item));
  };

  Nav.prototype.renderItem = function (item) {
    var components = [];

    if (item.imageurl) {
      components.push(React.createElement(Image, {
        key: "image",
        className: "img",
        text: item.title,
        imageurl: item.imageurl
      }));
    }

    if (item.icon) {
      components.push(React.createElement(Icon, {
        key: "icon",
        type: item.icon
      }));
    }

    if (item.component) {
      components.push(this.renderComponent(item));
    }

    components.push(React.createElement(Text, {
      key: "text",
      text: item.title
    }));
    return components;
  };

  Nav.prototype.renderComponent = function (item) {
    var _a = item.component,
        name = _a.name,
        otherProps = __rest(_a, ["name"]);

    var props = Object.assign({}, extendsParentProps(otherProps, this.props), {
      key: 'component'
    });
    return createElement(ComponentsManager.get(name), props);
  };

  return Nav;
}(Component);

export { Nav };